import * as fromNavigation from './Navigation.Reducer';
import * as fromYear from './Years.Reducer';
import * as fromStates from './States.Reducer';
import * as fromCounties from './Counties.Reducer';
import * as fromPriceDiscovery from './PriceDiscoveryReducer';
import * as fromCommodity from './CommodityReducer';
import {INavigationModel} from "../models/INavigationModel";
import * as fromFormFilter from './FormFilter.Reducer';
import {IYear} from "../models/IYearModel";
import {IStates} from "../models/IStatesModel";
import {IFormFilterModel} from "../models/IFormFilterModel";
import {ICountyModel} from "../models/ICountyModel";
import {IPriceDiscoveryModel} from "../models/IPriceDiscoveryModel";
import {ICommodities} from "../models/ICommodityModel";

export interface AppState {
  readonly navigation: INavigationModel;
  readonly years: Array<IYear>;
  readonly states: Array<IStates>;
  readonly counties: Array<ICountyModel>;
  readonly formFilterSelections: IFormFilterModel;
  readonly priceDiscovery: Array<IPriceDiscoveryModel>;
  readonly commodities: Array<ICommodities>;
}

export const reducers = {
  navigation: fromNavigation.reducer,
  years: fromYear.reducer,
  states: fromStates.reducer,
  counties: fromCounties.reducer,
  formFilterSelections: fromFormFilter.reducer,
  priceDiscovery: fromPriceDiscovery.reducer,
  commodities: fromCommodity.reducer
};
